// extracted by mini-css-extract-plugin
export default {"saleText":"DH5MmI","promotionalItem":"OjgQT2","slidingContainer":"SQ23Ms","slidingText":"ymhvUX","slideRightToLeft":"lE2Fyj","slidingItem":"OoZtC4"};